import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import { inject, observer } from 'mobx-react';

import NavItem from '@molecules/NavItem';
import NavItems from '@constants/NaviItems';

import Storage from '@utils/Storage';

const NavBar = ({ onMobileClose, openMobile, entities, setUserInfo }) => {
  const classes = useStyles();
  const location = useLocation();
  const [user, setUser] = useState({
    email: '',
    avatar: '/static/images/avatars/avatar_6.png',
    jobTitle: '파트너스 코리아',
    name: '관리자'
  });
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname, onMobileClose, openMobile]);

  useEffect(() => {
    if (entities.userInfo) {
      setUser(entities.userInfo);
      return;
    }
    const storedUserInfo = Storage.get('userInfo');
    if (storedUserInfo) {
      setUserInfo(storedUserInfo);
      setUser(storedUserInfo);
    } else {
      window.location.href = '/';
    }
  }, [setUserInfo, setUser, entities.userInfo]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box alignItems="center" display="flex" flexDirection="column" p={2}>
        <Avatar
          className={classes.photoURL}
          component={RouterLink}
          src={user.avatar}
          to="/app/account"
        />
        <Typography className={classes.name} color="textPrimary" variant="h5">
          {user.displayName}
        </Typography>
        <Typography color="textSecondary" variant="body2">
          {user.email}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {NavItems.map(item => {
            return (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
              />
            );
          })}
        </List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default inject(({ applicationStore }) => ({
  entities: applicationStore.entities,
  setUserInfo: applicationStore.setUserInfo
}))(observer(NavBar));
